export default "__VITE_ASSET__862ef5f5__"